import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AllMenuHeader from "../Header/AllMenuHeader/AllMenuHeader";
import AllMenuBreadcrumb from "./AllMenuBreadcrumbs";
import AllMenuSlidingCards from "./AllMenuSlidingCards";
import { AllMenuCards } from "./AllMenuCards";
import { Slidingcard } from "./Slidingcard";
import Caterer from "./Caterer";
import TrendingMenu from "./TrendingMenu";
import CateringCards from "./CateringCards";
import { CatererSlider } from "./CatererSlider";
import DiscountFooterSection from "../DiscountFooterSection/DiscountFooterSection";
import Footer from "../Footer/Footer";
import AllMenuNavbr from "./AllMenuNavbr";
import { useGetMenuCountryViseQuery } from "../../api/menu";
import { useGetCuisineQuery } from '../../api/cuisine'
import { useGetAllPublicCaterersQuery } from "api/caterer";
import { useLocation } from "react-router"
import { useSearchMutation } from "api/search";
import Swal from "sweetalert2";

export default function AllMenu() {

  const { data: menus } = useGetMenuCountryViseQuery();
  const { data: caterers } = useGetAllPublicCaterersQuery();
  const { data: cuisine } = useGetCuisineQuery();
  const [addSearch, { isLoading }] = useSearchMutation()
  console.log("caterers", menus);
  console.log("cuisine", cuisine)
  const location = useLocation();
  let params = new URLSearchParams(location.search)
  params = params.get("q")
  console.log("params", params)
  const [searchedMenu, setMenu] = React.useState([]);
  const [searchedCaterers, setCaterers] = React.useState([]);

  useEffect(() => {
    if (params) {
      addSearch({ search: params }).then((res) => {
        console.log(res)
        if (res.error) {
          Swal.fire("Location Not Found", "", "error")
          console.log(res.error)
        } else {
          setMenu(res.data.data.menues);
          setCaterers(res.data.data.caterers);
        }
      })
    }
  }, [params])

  return (
    <>

      <Box
        sx={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <Box>
          <AllMenuNavbr />
        </Box>

        <Box sx={{ margin: "30px" }}>
          <Box mt="24px">
            <AllMenuBreadcrumb />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "row", mt: "24px" }}>
            <Box>
              <Typography
                sx={{
                  fontSize: {
                    xl: "56px",
                    lg: "56px",
                    md: "56px",
                    sm: "46px",
                    xs: "30px",
                  },
                  width: { lg: "100%", md: "100%", sm: "100%", xs: "350px" },
                  fontWeight: "600",
                  display: "inline",
                }}
              >
                Discover our menu from best caterer in{" "}
                <Box
                  color="primary"
                  sx={{
                    fontSize: {
                      xl: "56px",
                      lg: "56px",
                      md: "56px",
                      sm: "46px",
                      xs: "30px",
                    },
                    fontWeight: "600",
                    color: "#2b817b",
                    display: "inline",
                  }}
                >
                  {params}
                </Box>
              </Typography>
            </Box>
            {/* <Box>
              <Typography
                color="primary"
                sx={{ fontSize: {lg: "56px", md: "56px", sm: "46px", xs: "40px"}, fontWeight: "600", paddingLeft: {lg: "3px", md: "6px", sm: "0px", xs: "0px"} }}
              >
                
              </Typography>
            </Box> */}
          </Box>

          <Box>
            <Box pt="32px">
              {/* <AllMenuSlidingCards /> */}
              <Slidingcard />
            </Box>
          </Box>

          <Box mt="120px">
            <AllMenuCards cuisine={cuisine?.data} />
          </Box>

          <Box sx={{ mt: "16px" }}>
            {/* <Caterer /> */}
            <CatererSlider caterers={caterers?.data} />
          </Box>

          <Box mt="80px" mb="80px">
            <TrendingMenu menus={menus?.data} />
          </Box>

          <Box mb="96px">
            <CateringCards />
          </Box>

          <Box>
            <DiscountFooterSection />
          </Box>
        </Box>

        <Box mt="80px">
          <Footer />
        </Box>
      </Box>

    </>
  )

}
